import { Stack, Text, Textarea } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { SelectionCriterionType, ViewDocumentAsOwnerDto } from "../../../../autogen/bff-api";
import { verdictToStatusVariant } from "../../../../common/components/StatusVariant";
import { CriterionTypeBadge } from "../../../sourcing-events/bid-readonly/CriterionTypeBadge";
import { ReadonlyAnswerCard, ReadonlyFieldLabel } from "../../../sourcing-events/bid-readonly/ReadonlyAnswerCard";
import { QualificationVerdictControl } from "./QualificationVerdictControl";

interface Props {
  type: SelectionCriterionType | null;
  name: string;
  documentationRequirement?: string | null;
  supplierDescription?: string | null;
  supplierEvidence?: ViewDocumentAsOwnerDto[];
  verdict: boolean | null;
  comment: string;
  onVerdictChange: (value: boolean | null) => void;
  onCommentChange: (value: string) => void;
  isReadOnly?: boolean;
}

export const QualificationReviewCard = ({
  type,
  name,
  documentationRequirement,
  supplierDescription,
  supplierEvidence = [],
  verdict,
  comment,
  onVerdictChange,
  onCommentChange,
  isReadOnly,
}: Props) => {
  const { t } = useTranslation();

  return (
    <ReadonlyAnswerCard
      accent={verdictToStatusVariant(verdict)}
      badge={<CriterionTypeBadge type={type} />}
      title={name}
      descriptionLabel={String(t("Documentation requirement"))}
      descriptionHtml={documentationRequirement}
      answer={supplierDescription ? { kind: "text", value: supplierDescription } : { kind: "empty" }}
      evidence={supplierEvidence.map((doc) => ({ id: doc.id, name: doc.name }))}
      headerAction={<QualificationVerdictControl value={verdict} onChange={onVerdictChange} isReadOnly={isReadOnly} />}
      footer={
        <Stack spacing="2">
          <ReadonlyFieldLabel>{t("Evaluation comment")}</ReadonlyFieldLabel>
          {isReadOnly && comment ? (
            <Text fontSize="sm" color="smText" whiteSpace="pre-wrap" maxW="82ch">
              {comment}
            </Text>
          ) : (
            <Textarea
              value={comment}
              onChange={(e) => onCommentChange(e.target.value)}
              placeholder={isReadOnly ? undefined : String(t("Write comment..."))}
              rows={3}
              isDisabled={isReadOnly}
              resize="vertical"
            />
          )}
        </Stack>
      }
    />
  );
};
